
import OktaVerifyMobileSetupInstructions from '../../../components/okta-verify-enroll/OktaVerifyMobileSetupInstructions';
import EnrollPollBaseCustomizer from './base';

export default class EnrollPollMobileSetupCustomizer extends EnrollPollBaseCustomizer {
  async shouldCustomize() {
    return (await super.shouldCustomize()) && this.selectedChannel === 'samedevice';
  }

  async customize() {
    await super.customize();
    this.customizeOktaVerifySetupInstructions();
    this.replaceComponents();
  }

  private customizeOktaVerifySetupInstructions() {
    const sameDeviceSetupComponent: JQuery<HTMLElement> = jQueryCourage('.sameDevice-setup');
    if (sameDeviceSetupComponent.length) {
      this.renderForgeAndHideOktaComponent({
        id: 'same-device-setup',
        oktaComponent: sameDeviceSetupComponent,
        forgeComponent: <OktaVerifyMobileSetupInstructions oktaComponent={sameDeviceSetupComponent} />,
      });
    }
  }

}
